import React, { useState, useEffect } from 'react'
import { Container, Row, Col, Card, CardBody } from 'reactstrap'
import HeaderCard from '../Common/Component/HeaderCard'
import { getDataWithClassforInstructor } from '../../lib/classdetailview'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentCard } from '../Common/StudentCard'
import { Link } from 'react-router-dom'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const StudentGrid = ({ classId, className }) => {
	const [students, setStudents] = useState([])
	const [loading, setLoading] = useState(true)
	const { user } = useAuth()
	const layout = useLayout()
	const role = useRoleBasedUrl()

	useEffect(() => {
		const fetchStudents = async () => {
			if (!classId || !user?.id) return

			try {
				setLoading(true)
				const studentData = await getDataWithClassforInstructor(classId, user.id)
				setStudents(studentData)
			} catch (error) {
				console.error('Error fetching students:', error)
			} finally {
				setLoading(false)
			}
		}

		fetchStudents()
	}, [classId, user?.id])

	if (loading) {
		return (
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<CardBody>
								<div className="text-center">
									<div className="spinner-border text-primary" role="status">
										<span className="sr-only">Loading students...</span>
									</div>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		)
	}

	return (
		<Container fluid={true}>
			<Row>
				<Col sm="12">
					<Card>
						<HeaderCard
							title={`${className} - Students`}
							subTitle={`View all students in ${className}`}
							rightContent={
								<Link to={`${process.env.PUBLIC_URL}/${role}/class-management/add-task/${classId}/Class/${layout}`} className="btn btn-primary">
									<i className="fa fa-plus me-2"></i>
									Add Task to Class
								</Link>
							}
						/>
						<CardBody>
							{students.length > 0 ? (
								<Row>
									{students.map((student) => (
										<StudentCard key={student.id} data={student} showLinks={true} showEditIcon={true} cardSize="4" className="col-ed-4 box-col-4">
											<Link
												to={`${process.env.PUBLIC_URL}/${role}/class-management/student-update/${student.studentId}/${layout}`}
												className="btn btn-outline-secondary btn-sm"
											>
												Update
											</Link>
										</StudentCard>
									))}
								</Row>
							) : (
								<div className="text-center py-5">
									<i className="fa fa-users fa-3x text-muted mb-3"></i>
									<h5 className="text-muted">No students found</h5>
									<p className="text-muted">No students are currently assigned to this class.</p>
								</div>
							)}
						</CardBody>
					</Card>
				</Col>
			</Row>
		</Container>
	)
}

export { StudentGrid }
